import React from 'react';
import PropTypes from 'prop-types';
import Lightbox from '../lightbox/lightbox';
import { FSHomePageLightBoxHeader } from './fs_home_page_light_box_header';
import { FSHomePageLightBoxContent } from './fs_home_page_light_box_content';

function FSHomePageLightBox(props) {
    return (
        <Lightbox
            opened={props.visible}
            onClose={props.onClose}
            additionalClassNames={['fs-home-page-light-box__lightbox']}
        >
            <div className="fs-home-page-light-box">
                <FSHomePageLightBoxHeader />
                <FSHomePageLightBoxContent onProceed={props.onProceed} />
            </div>
        </Lightbox>
    );
}

FSHomePageLightBox.propTypes = {
    visible: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onProceed: PropTypes.func.isRequired,
};

export { FSHomePageLightBox };
